
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/useToast";

interface DeviceSettingsProps {
  deviceSpecificSettings: Record<string, any>; // Replace with proper type
  setDeviceSpecificSettings: (settings: Record<string, any>) => void;
}

const DeviceSettings: React.FC<DeviceSettingsProps> = ({
  deviceSpecificSettings,
  setDeviceSpecificSettings
}) => {
  const { toast } = useToast();
  
  const updateSetting = (key: string, value: any) => {
    setDeviceSpecificSettings({
      ...deviceSpecificSettings,
      [key]: value
    });
  };
  
  const saveSettings = () => {
    // This is a placeholder for actual save functionality
    toast({
      title: "הגדרות נשמרו",
      description: "הגדרות המכשיר נשמרו בהצלחה",
    });
  };
  
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-4">
            <h3 className="text-lg font-medium">הגדרות תצוגה</h3>
            
            <div className="flex items-center space-x-2">
              <Switch
                id="full-screen"
                checked={deviceSpecificSettings?.fullScreen || false}
                onCheckedChange={(checked) => updateSetting('fullScreen', checked)}
              />
              <Label htmlFor="full-screen">מסך מלא</Label>
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="orientation">כיוון מסך</Label>
              <Select
                value={deviceSpecificSettings?.orientation || 'landscape'}
                onValueChange={(value) => updateSetting('orientation', value)}
              >
                <SelectTrigger id="orientation">
                  <SelectValue placeholder="בחר כיוון מסך" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="landscape">אופקי</SelectItem>
                  <SelectItem value="portrait">אנכי</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="refresh-rate">זמן רענון אוטומטי (דקות)</Label>
              <Select
                value={String(deviceSpecificSettings?.refreshRate || 60)}
                onValueChange={(value) => updateSetting('refreshRate', Number(value))}
              >
                <SelectTrigger id="refresh-rate">
                  <SelectValue placeholder="בחר זמן רענון" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="15">15 דקות</SelectItem>
                  <SelectItem value="30">30 דקות</SelectItem>
                  <SelectItem value="60">שעה</SelectItem>
                  <SelectItem value="120">שעתיים</SelectItem>
                  <SelectItem value="240">4 שעות</SelectItem>
                  <SelectItem value="720">12 שעות</SelectItem>
                  <SelectItem value="1440">24 שעות</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Button onClick={saveSettings} className="w-full">
        שמור הגדרות
      </Button>
    </div>
  );
};

export default DeviceSettings;
